// @flow
import React, {FunctionComponent, PropsWithChildren} from 'react';
import {Stack, SxProps, Theme} from "@mui/material";

type FlexStackProps = PropsWithChildren<{
    sx?: SxProps<Theme>
    spacing?: number
}>;

const FlexStack: FunctionComponent<FlexStackProps> = ({sx, spacing = 2, children}) => {
    return (
        <Stack spacing={spacing} sx={{padding: 1, maxWidth: 960, ...sx}} justifyContent="flex-start">
            {children}
        </Stack>
    );
};

export default FlexStack
